import { render } from "./AddPos.vue?vue&type=template&id=6c4971ba"
import script from "./AddPos.vue?vue&type=script&lang=js"
export * from "./AddPos.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__